import type { OptionType } from "components/inputs";

export const normalizeValue = (val: unknown): unknown => {
  if (val == null) return val;

  if (Array.isArray(val)) {
    return val.map((item: OptionType) =>
      item && item.value != null ? item.value : null,
    );
  }

  if (typeof val === "object") {
    return (val as OptionType).value;
  }

  if (["string", "boolean", "number"].includes(typeof val)) {
    return val;
  }

  console.error("Unexpected form value type:", typeof val, val);
  return val;
};
